<template>
    <div class="export-data">
        <el-form ref="form" :rules="rules" :model="formData" @submit.native.prevent label-width="120px" class="pr60">
            <el-form-item label="文件名称：" prop="filename" class="label-required">
                <el-input
                    v-model.trim="formData.filename"
                    maxlength="100"
                    show-word-limit
                    @keyup.enter.native.prevent.stop="handleOnSubmit"
                    placeholder="请输入文件名称"
                    class="word-limit-input"></el-input>
            </el-form-item>
        </el-form>
         <div  class="tac">
            <el-button type="default" @click="()=>$emit('close')" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleOnSubmit" :loading="loading" class="action-btn ml20">导出</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'cbs' , 'filename'],
    name: 'ExportDataModal',
    data() {
        const _this = this;
        return {
            loading: false,
            formData:{
                filename: _this.filename || '',
            },
            rules:{
                filename:[
                    {required: true, message: '请输入文件名称', trigger: 'blur'},
                    {max: 100, message: '最多100个字', trigger: 'blur'},
                ]
            }
        }
    },
    methods: {
        handleOnSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.loading = true;
                        await this.cbs.onSubmit(this.formData.filename)
                    } catch (error) {
                        this.$message.error(error.info || error.message)
                    }finally {
                        this.loading = false;
                    }
                } else {
                    return false;
                }
            });
            
        }
    }
}
</script>

<style lang="scss" scoped>
.export-data {
   .action-btn {
        width: 120px;
    }

    ::v-deep .word-limit-input .el-input__suffix{
        right: -50px;
    } 
}
</style>